import request from '../tools/request'
import { HTTP } from './http'
const { GET } = request

// 获取前台用户管理范围权限的响应类型
export interface UserScopePermissionRes {
  name: string
  permission: string
  permissionList: string[]
  permissionName: string
  permissionNameList: string[]
  realName: string
  supplierId: string
  supplierUserId: string
}

// 获取前台用户管理范围权限
export const GET_SUPPLIER_USER_SCOPE_PERMISSION = () =>
  GET<UserScopePermissionRes>(`${HTTP}/product/getSupplierUserScopePermission`)import request from '../tools/request'
import { HTTP } from './http'
const { GET } = request

// 获取前台用户管理范围权限的响应类型
export interface UserScopePermissionRes {
  name: string
  permission: string
  permissionList: string[]
  permissionName: string
  permissionNameList: string[]
  realName: string
  supplierId: string
  supplierUserId: string
}

// 获取前台用户管理范围权限
export const GET_SUPPLIER_USER_SCOPE_PERMISSION = () =>
  GET<UserScopePermissionRes>(`${HTTP}/product/getSupplierUserScopePermission`)